var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightLongArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: "25px",
    height: "14px",
    viewBox: "0 0 25 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Long Arrow Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navigation",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation_Mobile_1.0A_DegreeCourses_Open_1",
    transform: "translate(-35.000000, -97.000000)",
    fill: "#001823"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Top-Hat",
    transform: "translate(0.000000, 68.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CTA/Back",
    transform: "translate(34.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/16px/Teal/LongArrow",
    transform: "translate(13.000000, 12.000000) translate(-13.000000, -12.000000) translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Stick",
    x: 0,
    y: 7.5,
    width: 24,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,3 L23,4 L14,4 L14,13 L13,13 L13,3 L23,3 Z",
    id: "Combined-Shape",
    transform: "translate(18.000000, 8.000000) scale(-1, 1) rotate(-45.000000) translate(-18.000000, -8.000000) "
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightLongArrow);
export default __webpack_public_path__ + "static/media/right-long-arrow.57859f99fad7d6ce0dde0b5b33eb68ac.svg";
export { ForwardRef as ReactComponent };